import axios from '../api/config'

//统一接口管理

//注册接⼝
export const registerApi = (mobile, emailAddr, password, accountType, vcode, verKey) =>
  axios.post('/api/v1/pub/register', {
    mobile,
    emailAddr,
    password,
    accountType,
    vcode,
    verKey
  })

//修改密码接⼝
export const updatePwdApi = resetPwdReq => axios.post('/api/v1/pri/user/updatePwd', resetPwdReq)

//重置密码接⼝
export const resetPwdApi = resetPwdReq => axios.post('/api/v1/pub/resetPwd', resetPwdReq)

//发送验证码
export const sendEmailCodeApi = mobile => axios.post('/api/v1/pub/sendEmailCode', { mobile })

//登录接口
export const loginApi = (mobile, pwd, vcode, verKey) =>
  axios.post('/api/v1/pub/login', {
    mobile,
    pwd,
    vcode,
    verKey
  })

//生成随机验证码
export const makeCodeApi = () => axios.get('/api/v1/pub/captcha')

//验证输入验证码
export const checkVCodeApi = vcode =>
  axios.post('/api/v1/pub/verify', {
    vcode
  })

//注销接口
export const logOutApi = (token, mobile) => axios.post('/api/v1/pub/logOut', { token, mobile })

//获取菜单接口
export const getmenuApi = () => axios.get('/api/v1/pri/menuPermition/menuList')

//根据mobile获取单个用户信息接口（未登录）
export const userinfoApi = mobile =>
  axios.post('/api/v1/pri/user/findUserByMobile', {
    mobile
  })

//登录后获取单个用户信息
//根据mobile获取单个用户信息接口
export const userinfoLoginApi = mobile =>
  axios.post('/api/v1/pri/user/find_by_token', {
    mobile
  })

//查询用户信息接口
export const userinfoListApi = mobile =>
  axios.post('/api/v1/pri/user/userinfo', {
    mobile
  })

//分页查询用户信息接口
export const pageUserinfoApi = (page, size, mobile) =>
  axios.post('/api/v1/pri/user/pageUserInfo', {
    page,
    size,
    mobile
  })

//分页查询企业用户信息接口
export const pageCompanyUserinfoApi = (page, size, mobile) =>
  axios.post('/api/v1/pri/user/pageCompanyUserInfo', {
    page,
    size,
    mobile
  })

//修改用户信息接口
export const updateUserApi = registerUser => axios.post('/api/v1/pri/user/updateUser', registerUser)

//删除用户接口
export const delUserApi = mobile =>
  axios.post('/api/v1/pri/user/delUser', {
    mobile
  })

//分页查询模板信息接口
export const pageContractTempInfoApi = (page, size, templateId, tempName) =>
  axios.post('/api/v1/pri/contTemp/pageContTempInfo', {
    page,
    size,
    templateId,
    tempName
  })

//模板上传接口
export const contTempUploadApi = file =>
  axios.post(
    '/api/v2/pri/contTemp/uploadTemp',
    {
      file
    },
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )

//分页查询合同信息接口
export const pageContractInfoApi = (page, size, contractId, docTitle) =>
  axios.post('/api/v1/pri/contract/pageContractInfo', {
    page,
    size,
    contractId,
    docTitle
  })

//合同上传接口
export const contractUploadApi = file =>
  axios.post(
    '/api/v2/pri/contract/uploadContrct',
    {
      file
    },
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )

//获取个人实名认证地址
export const getPersonVerifyUrlApi = (mobile, customerName, customerIdentNo) =>
  axios.post('/api/v2/pri/user/personAuthtic', {
    mobile,
    customerName,
    customerIdentNo
  })

//获取实名认证交易号
export const getPersonAuthStatusApi = customerId => axios.post('/api/v1/pri/user/personAuthStatus', { customerId })

//获取企业实名认证地址(带参)
export const getCompanyVerifyUrlApi = username =>
  axios.get('/api/v2/pri/user/companyAuthtic', {
    params: { username: username }
  })

//变更企业信息，重新获取企业实名认证地址(无带参)
export const getCompanyVerifyUrlUpdateToAuthApi = () => axios.post('/api/v2/pri/user/companyAuthticUpdateToAuth')

//获取企业实名认证地址(无参)
export const getCompanyVerifyUrlApi1 = () => axios.post('/api/v2/pri/user/companyAuthtic1')

//查询个人/企业实名认证状态
export const getVerifyStatusApi = accountType =>
  axios.post('/api/v2/pri/user/verifyStatus', {
    accountType
  })

//删除模板接口
export const delContTempApi = templateId =>
  axios.post('/api/v1/pri/contTemp/delContTemp', {
    templateId
  })
//删除合同文件接口
export const delContractApi = (contractId, fileId) =>
  axios.post('/api/v1/pri/contract/delContract', {
    contractId,
    fileId
  })

//获取查看合同地址接口
export const viewContractApi = (contractId, organizationA, organizationB, uuid) =>
  axios.post('/api/v2/pri/contract/viewContract', {
    contractId,
    organizationA,
    organizationB,
    uuid
  })

//合同信息编辑接口
export const detailEditContractApi = (contractId, docTitle, contractType) =>
  axios.post('/api/v1/pri/contract/editContract', {
    contractId,
    docTitle,
    contractType
  })

//合同信息保存接口
export const saveEditContractApi = (contractId, isSignB) =>
  axios.post('/api/v1/pri/contract/editContract', {
    contractId,
    isSignB
  })

//发起合同接口
export const sendContractApi = contract => axios.post('/api/v1/pri/contract/sendContract', contract)

//查询已发起合同
export const pageContractSendInfoApi = (page, size, currentUser, isSignA, isSignB, contractId, docTitle) =>
  axios.post('/api/v1/pri/contractsenduser/pageSendContractInfo', {
    page,
    size,
    currentUser,
    isSignA,
    isSignB,
    contractId,
    docTitle
  })
//分页查询所有已发起合同
export const pageAllContractSendInfoApi = (page, size, currentUser, contractId, docTitle) =>
  axios.post('/api/v1/pri/contractsenduser/pageAllSendContractInfo', {
    page,
    size,
    currentUser,
    contractId,
    docTitle
  })

//删除已发起的合同
export const delSendContUserApi = (contractId, fileId) =>
  axios.post('/api/v1/pri/contractsenduser/delSendContract', {
    contractId,
    fileId
  })

//提交完成已发起的合同
export const completeSendContUserApi = (contractId, uuid) =>
  axios.post('/api/v1/pri/contractsenduser/completeSendContUser', {
    contractId,
    uuid
  })

//添加旗下用户api
export const addCustomerApi = userCustomersInfo => axios.post('/api/v1/pri/userAndCustomer/addCustomer', userCustomersInfo)

//删除旗下用户api
export const delCustomerApi = id => axios.get('/api/v1/pri/userAndCustomer/delCustomer', { params: { id: id } })

//自动生成印章api
export const autoSealApi = (remark, content) => axios.post('/api/v2/pri/sealManage/autoSeal', { remark, content })

//编辑印章api
export const editSealApi = (remark, signatureId) => axios.post('/api/v2/pri/sealManage/editSeal', { remark, signatureId })

//分页查询旗下用户信息api
export const pageCustomerInfoApi = (page, size, customerCid, customerUname) =>
  axios.post('/api/v1/pri/userAndCustomer/pageCustomerInfo', {
    page,
    size,
    customerCid,
    customerUname
  })

//获取旗下客户信息
export const getCustomersApi = mobile =>
  axios.get('/api/v1/pri/userAndCustomer/getCustomers', {
    params: { mobile: mobile }
  })

//获取合同签署地址
export const getSignPageApi = signPageReq => axios.post('/api/v2/pri/contract/getSignPage', signPageReq)

//获取合同骑缝签署地址
export const getQfSignPageApi = signPageReq => axios.post('/api/v2/pri/contract/getQfSignPage', signPageReq)

//获取当前登录用户organization
export const getCurrentOrganizationApi = () => axios.get('/api/v1/pri/user/getCurrentOrganizationByUsername')

//获取当前登录用户username
export const getCurrentUsernameApi = () => axios.get('/api/v1/pri/user/getCurrentUsername')

//合同文件下载api
export const downloadContApi = (contractId, docTitle, conUuid) =>
  axios.post(
    '/api/v2/pri/contract/downloadContract',
    {
      contractId,
      docTitle,
      conUuid
    },
    {
      responseType: 'blob'
    }
  )

//手动合同归档api
export const contFilingApi = (contractId, conUuid) =>
  axios.get('/api/v2/pri/contract/contFiling', {
    params: { contractId: contractId, conUuid: conUuid }
  })

//手动合同回传lomsapi
export const contToLomsApi = contract => axios.post('/api/v1/pri/contract/handleBackToLoms1', contract)

//角色信息查询
export const pageAuthrizeInfoApi = (page, size, username, customerName, organization) =>
  axios.post('/api/v1/pri/userrole/pageAuthrizeInfo', {
    page,
    size,
    username,
    customerName,
    organization
  })

//给用户添加角色
export const addUserRoleApi = userRole => axios.post('/api/v1/pri/userrole/addRole', userRole)

//修改用户角色
export const updateUserRoleApi = userRole => axios.post('/api/v1/pri/userrole/updateRole', userRole)

//移交角色
export const transferRoleApi = userRole => axios.post('/api/v1/pri/userrole/transferRole', userRole)

//保存使用协议富文本
export const saveAgreementTextApi = agreement => axios.post('/api/v1/pri/agreement/saveAreementText', { agreement })

//查询使用询协议富文本
export const getAgreementTextApi = id => axios.get('/api/v1/pri/agreement/getAgreementText', { params: { id: id } })

//保存隐私政策富文本
export const savePrivacyTextApi = privatePolicy => axios.post('/api/v1/pri/privacyPolicy/savePrivacyText', { privatePolicy })

//查询隐私政策富文本
export const getPrivacyTextApi = id => axios.get('/api/v1/pri/privacyPolicy/getPrivacyText', { params: { id: id } })

//保存公告富文本
export const saveAnnouncementTextApi = announcement => axios.post('/api/v1/pri/announcement/saveAnnouncementText', { announcement })

//查询公告富文本
export const getAnnouncementTextApi = id => axios.get('/api/v1/pri/announcement/getAnnouncementText', { params: { id: id } })

//获取用户操作日志
export const getActionLogApi = (page, size, username) =>
  axios.post('/api/v1/pri/actionlog/getLogs', {
    page,
    size,
    username
  })
//获取所有印章图片
export const getAllSealApi = () => axios.post('/api/v2/pri/sealManage/getAllSeals')

//上传印章图片base64到法大大
export const uploadSealApi = (signatureImgBase64, remark) => axios.post('/api/v2/pri/sealManage/uploadSeal', { signatureImgBase64, remark })

//删除印章
export const delSealApi = signatureId => axios.get('/api/v2/pri/sealManage/delSeal', { params: { signatureId: signatureId } })

//获取查看签章地址接口
export const viewSelfFileApi = (appNo, organization, id) =>
  axios.post('/api/v2/pri/fddSelfFile/viewSelfFile', {
    appNo,
    organization,
    id
  })

//查询已发起签章
export const pageSelfFileInfoApi = (page, size, currentUser, isSign, appNo, docTitle) =>
  axios.post('/api/v1/pri/selFile/findSelfFileByPage', {
    page,
    size,
    currentUser,
    isSign,
    appNo,
    docTitle
  })

//获取签章签署地址
export const getSignSelffilePageApi = selfFileModel => axios.post('/api/v2/pri/fddSelfFile/getSealSignPage', selfFileModel)

//删除已发起的签章
export const delSelfFileApi = (appNo, id) =>
  axios.post('/api/v1/pri/selFile/delSelFile', {
    appNo,
    id
  })

//提交完成已发起的签章
export const completeSelfFileApi = (appNo, id) =>
  axios.post('/api/v1/pri/selFile/completeSelFile', {
    appNo,
    id
  })

//查询授权印章
export const pageSealPriInfoApi = (signatureId, currentUser, type) =>
  axios.post('/api/v2/pri/sealManage/getSealPriInfoList', {
    signatureId,
    currentUser,
    type
  })

//保存印章授权
export const saveSealPriApi = (signatureId, currentUser, remark, sealList) =>
  axios.post('/api/v2/pri/sealManage/saveSealPri', { signatureId, currentUser, remark, sealList })

//获取查看签章地址接口
export const viewEmpSignApi = (appNo, organization, id) =>
  axios.post('/api/v2/pri/fddEmpSign/viewEmpSign', {
    appNo,
    organization,
    id
  })

//查询已发起签章
export const pageEmpSignInfoApi = (page, size, currentUser, isComSign, appNo, docTitle) =>
  axios.post('/api/v1/pri/empSign/findEmpSignByPage', {
    page,
    size,
    currentUser,
    isComSign,
    appNo,
    docTitle
  })

//获取签章签署地址
export const getEmpSignPageApi = empSignModel => axios.post('/api/v2/pri/empSign/getSealSignPage', empSignModel)

//删除已发起的签章
export const delEmpSignApi = (appNo, id) =>
  axios.post('/api/v1/pri/empSign/delEmpSign', {
    appNo,
    id
  })

//提交完成已发起的签章
export const completeEmpSignApi = (appNo, id) =>
  axios.post('/api/v1/pri/empSign/completeEmpSignFile', {
    appNo,
    id
  })

//离职协议发送短信通知
export const sendMsgEmpSignApi = (appNo, id) =>
  axios.post('/api/v1/pri/empSign/doSendMsgEmpSign', {
    appNo,
    id
  })
